export default __webpack_public_path__ + "static/03-a-underline-evidence-based-132b08922cdf3301d714c3dc6a4354f8.svg";